<template>
  <l-container-toolbar>
    <div>
      <span class="rounded-full h-10 w-10 flex items-center justify-center" :class="color">
        <font-awesome-icon :icon="icon" class="text-xl text-white" />
      </span>
    </div>
    <div class="items-center justify-center ml-2 self-center">
      <h2 class="text-lg font-bold">{{ text }}</h2>
    </div>
  </l-container-toolbar>
</template>

<script>
import LContainerToolbar from "./LContainerToolbar";
export default {
  name: "LContainerTitle",
  components: { LContainerToolbar },
  props: ["text", "icon", "color"]
};
</script>

